import { render, staticRenderFns } from "./recommendlike.vue?vue&type=template&id=74be5ee8"
import script from "./recommendlike.vue?vue&type=script&lang=js"
export * from "./recommendlike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports